(function () {
  var bar = document.querySelector('.stickybuy');
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!bar || !form) return;

  var show = function (on) { bar.classList.toggle('on', on); };

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { show(!e.isIntersecting); });
    }, { rootMargin: '0px 0px -40% 0px' });
    io.observe(form);
  }

  var btn = bar.querySelector('[data-sticky-submit]');
  if (btn) {
    btn.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }
})();
